// extracted by mini-css-extract-plugin
export default {"safari-rich-text-form":"RichTextForm_safari-rich-text-form__xa5cB"};